var _path, _rect, _rect2, _rect3, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgList(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 82,
    viewBox: "0 0 80 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 54.828v-46.5a4 4 0 00-4-4H17a4 4 0 00-4 4v5m50.5 67H17a4 4 0 01-4-4v-6m0-11v-12m0-11v-12m35.5-1h16m-16 19h16",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13.328,
    width: 14,
    height: 11,
    rx: 4,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 36.328,
    width: 14,
    height: 11,
    rx: 4,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 59.328,
    width: 14,
    height: 11,
    rx: 4,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 65.828,
    r: 14.5,
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60.328v5a1 1 0 001 1h4M25 22.828l4.793 4.793a1 1 0 001.414 0l9.293-9.293M25 41.828l4.793 4.793a1 1 0 001.414 0l9.293-9.293M25 60.828l4.793 4.793a1 1 0 001.414 0l9.293-9.293",
    stroke: "#504FE9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
export default SvgList;